import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Translations } from '../translate.service';
import { TranslationLoader } from './translation-loader';
import {
  AbstractHttpService,
  Response,
} from '../../http/abstract-http.service';

@Injectable({
  providedIn: 'root',
})
export class HttpTranslationLoaderService
  extends AbstractHttpService
  implements TranslationLoader
{
  /**
   * Basic http loading from settings
   */
  public load(lang: string): Observable<Translations | null> {
    return this.get<Translations>('/' + lang + '.json', {
      response: Response.json,
    });
  }
}
